(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3877],{

/***/ 33877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CMSButton": function() { return /* binding */ CMSButton; },
  "CMSButtonStyle": function() { return /* binding */ CMSButtonStyle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/index.tsx + 1 modules
var ChildrenContainer = __webpack_require__(38628);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/CMS/Button/style.module.scss
var style_module = __webpack_require__(39083);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/Button/item.tsx








var Item = function(param) {
    var data = param.data;
    var button_text = data.button_text, button_URL = data.button_URL, button_style = data.button_style, button_image = data.button_image;
    if (button_style === "Image") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            href: button_URL,
            as: button_URL,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: button_URL,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (style_module_default()).imgWrapper,
                    children: (button_image === null || button_image === void 0 ? void 0 : button_image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        layout: "fill",
                        className: (style_module_default()).img,
                        src: button_image.url,
                        alt: button_text
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        variant: button_style === "Outlined" ? "outlined" : "contained",
        color: "secondary",
        href: button_URL,
        className: classnames_default()((style_module_default()).button, (style_module_default())[button_style]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "h6",
            children: button_text
        })
    });
};

;// CONCATENATED MODULE: ./components/CMS/Button/index.tsx






var CMSButtonStyle;
(function(CMSButtonStyle) {
    CMSButtonStyle["TwoColumns"] = "Two_Column";
    CMSButtonStyle["ThreeColumns"] = "Three_Column";
})(CMSButtonStyle || (CMSButtonStyle = {}));
var CMSButton = function(param) {
    var layout = param.layout, button_collections = param.button_collections, button_collection = param.button_collection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: layout === CMSButtonStyle.TwoColumns ? (style_module_default()).twoColumnsContainer : (style_module_default()).threeColumnsContainer,
            children: [
                button_collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    data: button_collection
                }),
                button_collections && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 3,
                    children: button_collections.map(function(i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            md: layout === CMSButtonStyle.TwoColumns ? 6 : 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                data: i
                            })
                        }, i.id);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 39083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"twoColumnsContainer":"style_twoColumnsContainer__9XnCO","threeColumnsContainer":"style_threeColumnsContainer__ZN2W9","button":"style_button__xXLwb","Contained":"style_Contained__5a96j","MainCTA":"style_MainCTA__setS4","Outlined":"style_Outlined__aQgay","Large":"style_Large__zCWTA","imgWrapper":"style_imgWrapper__28aMX","img":"style_img__C48ff"};

/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ })

}]);